'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.save = save;

var _apiClient = require('../utils/http/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *   This DAO is for saving updated portal-level settings to disk.
 */

function save(_ref) {
  var portalId = _ref.portalId,
      key = _ref.key,
      data = _ref.data;

  var crmKey = 'crm:signup:' + key;
  var url = 'hubs/v1/hubs/' + portalId + '/settings';

  return _apiClient2.default.post(url, {
    query: { portalId: portalId },
    data: {
      hubId: portalId,
      internal: false,
      key: crmKey,
      value: data
    }
  });
}